import {
  FETCH_INVOICE_HISTORY_REQUEST,
  FETCH_INVOICE_HISTORY_SUCCESS,
  FETCH_INVOICE_HISTORY_FAILURE,
  FETCH_STATS_REQUEST,
  FETCH_STATS_SUCCESS,
  FETCH_STATS_FAILURE,
  FETCH_INVOICE_REQUEST,
  FETCH_INVOICE_SUCCESS,
  FETCH_INVOICE_FAILURE,
} from './types';

const initialState = {
  history:{
    loading: false,
    data: [],
    error: '',
  },
  stats:{
    loading: false,
    data: [],
    error: '',
  },
  invoice:{
    loading: false,
    data: {},
    error: '',
  }
};

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_INVOICE_HISTORY_REQUEST:
      return {
        ...state,
        history: {
          ...state.history,
          loading: true
        }
      }
    case FETCH_INVOICE_HISTORY_SUCCESS:
      return {
        ...state,
        history: {
          loading: false,
          data: action.payload,
          error: ''
        }
      }
    case FETCH_INVOICE_HISTORY_FAILURE:
      return {
        ...state,
        history: {
          loading: false,
          data: [],
          error: action.payload
        }
      }

      case FETCH_STATS_REQUEST:
        return {
          ...state,
          stats: {
            ...state.stats,
            loading: true
          }
        }
      case FETCH_STATS_SUCCESS:
        return {
          ...state,
          stats: {
            loading: false,
            data: action.payload,
            error: ''
          }
        }
      case FETCH_STATS_FAILURE:
        return {
          ...state,
          stats: {
            loading: false,
            data: [],
            error: action.payload
          }
        }

        case FETCH_INVOICE_REQUEST:
          return {
            ...state,
            invoice: {
              ...state.invoice,
              loading: true
            }
          }
        case FETCH_INVOICE_SUCCESS:
          return {
            ...state,
            invoice: {
              loading: false,
              data: action.payload,
              error: ''
            }
          }
        case FETCH_INVOICE_FAILURE:
          return {
            ...state,
            invoice: {
              loading: false,
              data: {},
              error: action.payload
            }
          }
    default: return state
  }
}

export default reducer;
